import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import index from "./store/index";
import i18n from "./locales/index";
import "./assets/global.css";
import dayjs from "dayjs";
import mitt from "mitt";
import Antd, { message } from "ant-design-vue";
import "ant-design-vue/dist/reset.css";
//import 'ant-design-vue/es/style/index.less';
import config from "@/config/index.js";
import tz from "@/utils/timezone";

let app = createApp(App);

app.config.globalProperties.$bus = new mitt();
app.config.globalProperties.$dateFormat = "DD/MM/YYYY";
app.config.globalProperties.$timeFormat = timeFormat;
app.config.globalProperties.$getHourMinute = getHourMinute;
app.config.globalProperties.$getFileName = getFileName;
app.config.globalProperties.$toTimeStamp = toTimeStamp;
app.config.globalProperties.$timeLocaleFormat = timeLocaleFormat;
app.config.globalProperties.$dayjs = dayjs;
app.config.globalProperties.$getFileUrl = getFileUrl;
app.config.globalProperties.$hasPermission = hasPermission;
app.config.globalProperties.$modalMaxWith = {
  large: "1320px",
  middle: "720px",
  small: "500px",
};
app.config.globalProperties.$tz = tz;
app.config.errorHandler = (err, instance, info) => {
  console.error("Global Error:", err);
  console.error("Info:", info);
  message.error("Произошла ошибка: " + (err.message || "Неизвестная ошибка"));
};

app.use(index).use(router).use(i18n).use(Antd).mount("#app");
function timeLocaleFormat(t) {
  if (!t) {
    return "";
  }
  if (typeof t != "number") {
    return t;
  }
  let d = new Date(t * 1000);
  let day = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Almaty",
    hour12: false,
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  }).format(d);

  return day;
}
function timeFormat(t, hm, s) {
  if (!t) {
    return "";
  }
  if (typeof t != "number") {
    return t;
  }
  if (s) {
    t = t / 1000;
  }
  let d = new Date(t);
  let day = d.getDate();
  let m = d.getMonth() + 1;
  let y = d.getFullYear();
  if (day.toString().length == 1) {
    day = "0" + day.toString();
  }
  if (m.toString().length == 1) {
    m = "0" + m.toString();
  }
  let h = d.getHours();
  let mn = d.getMinutes();
  if (h.toString().length < 2) {
    h = "0" + h;
  }
  if (mn.toString().length < 2) {
    mn = "0" + mn;
  }
  if (hm) {
    return `${day}/${m}/${y} ${h}:${mn}`;
  }
  return `${day}.${m}.${y}`;
}

function getHourMinute(t, s) {
  if (typeof t != "number") {
    return t;
  }
  if (s) {
    t = t / 1000;
  }
  let d = new Date(t * 1000);
  let h = d.getHours();
  let mn = d.getMinutes();
  if (h.toString().length < 2) {
    h = "0" + h;
  }
  if (mn.toString().length < 2) {
    mn = "0" + mn;
  }
  return `${h}:${mn}`;
}

function getFileName(url) {
  if (url && typeof url === "string") {
    if (url.indexOf("/") == -1) {
      return url;
    }
    return url.split("/")[url.split("/").length - 1];
  } else {
    return "";
  }
}

function toTimeStamp(time) {
  let e = time || 0;
  if (e) {
    return (dayjs(e).valueOf() / 1000).toFixed(0) * 1;
  } else {
    return e;
  }
}

function getFileUrl(url) {
  if (url.indexOf("http") == 0) {
    return url;
  }
  return config.baseURL + url;
}

function hasPermission(tag) {
  let isAdmin = store.state.permissionList.includes("z_admin_super_admin");
  if (isAdmin) {
    isAdmin = null;
    return true;
  }
  if (!tag) {
    return false;
  }
  if (tag == "__") {
    return true;
  }
  return store.state.permissionList.includes(tag);
}
